import React from 'react';
import { Ban } from 'lucide-react';

export type ReservationFormCancelConfirmModalProps = {
  open: boolean;
  customerName: string;
  date: Date;
  time: string;
  isCanceling: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export default function ReservationFormCancelConfirmModal({
  open,
  customerName,
  date,
  time,
  isCanceling,
  onClose,
  onConfirm,
}: ReservationFormCancelConfirmModalProps) {
  if (!open) return null;

  return (
    <div className="delete-confirm-overlay" role="dialog" aria-modal="true">
      <div className="delete-confirm-modal">
        <div className="delete-confirm-header">
          <Ban size={24} />
          <div>
            <h4>Cancelar reserva</h4>
            <p>Esta ação altera o status da reserva para cancelada.</p>
          </div>
        </div>
        <div className="delete-confirm-body">
          <p>
            Tem certeza que deseja cancelar a reserva de
            {' '}
            <strong>{customerName || 'cliente'}</strong>
            {' '}no dia{' '}
            <strong>
              {date.toLocaleDateString('pt-BR', {
                day: '2-digit',
                month: 'long',
                year: 'numeric'
              })}
            </strong>
            {time ? (
              <>
                {' '}às{' '}
                <strong>{time}</strong>
              </>
            ) : null}
            ?
          </p>
          <p className="delete-confirm-warning">
            A reserva sairá das reservas do dia e qualquer seleção de mesa vinculada será liberada.
          </p>
        </div>
        <div className="delete-confirm-actions">
          <button
            type="button"
            className="reservation-form-btn reservation-form-btn-cancel"
            onClick={onClose}
            disabled={isCanceling}
          >
            Voltar
          </button>
          <button
            type="button"
            className="reservation-form-btn reservation-form-btn-confirm-delete"
            onClick={onConfirm}
            disabled={isCanceling}
          >
            {isCanceling ? 'Cancelando...' : 'Confirmar cancelamento'}
          </button>
        </div>
      </div>
    </div>
  );
}
